import React from 'react';
import { BookOpen, Users, Heart } from 'lucide-react';
export function Authority() {
  return <section className="py-16 bg-secondary text-white" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2">
        <h2 className="text-3xl font-bold mb-8" data-id="element-3">
          Sobre el Método{' '}
          <span className="text-gray-400 text-xl font-normal block mt-2" data-id="element-4">
            (no es motivación, es sistema)
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10" data-id="element-5">
          <div className="bg-white/5 p-6 rounded-xl backdrop-blur-sm border border-white/10" data-id="element-6">
            <p className="text-lg leading-relaxed" data-id="element-7">
              "Creamos guías accionables diseñadas para{' '}
              <span className="text-accent-gold font-bold" data-id="element-8">mujer real</span>:
              oficina, casa, café con amigas."
            </p>
          </div>
          <div className="bg-white/5 p-6 rounded-xl backdrop-blur-sm border border-white/10" data-id="element-9">
            <p className="text-lg leading-relaxed" data-id="element-10">
              "No vendemos teoría: te decimos{' '}
              <span className="text-accent-gold font-bold" data-id="element-11">
                qué hacer cada día
              </span>{' '}
              para que tu cuerpo vuelva a sentirse satisfecho con comida real."
            </p>
          </div>
        </div>

        <div className="flex justify-center gap-8 opacity-60" data-id="element-12">
          <BookOpen className="h-8 w-8" data-id="element-13" />
          <Users className="h-8 w-8" data-id="element-14" />
          <Heart className="h-8 w-8" data-id="element-15" />
        </div>
      </div>
    </section>;
}